import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {FaqService} from "../../gestao/services/faq.service";
import {Faq} from "../../gestao/models/faq";

@Component({
    selector: 'app-visualizar-faq',
    templateUrl: './visualizar-faq.component.html',
    styleUrl: './visualizar-faq.component.css',
    standalone: false
})
export class VisualizarFaqComponent {
  @Input() faq = new Faq();
  @Input() habilitar = false;
  @Output() eventoFecharVisualizar = new EventEmitter<string>();

  constructor(private faqService: FaqService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['faq']) {
    }
    if (changes['habilitar']) {
    }
  }

  public fecharVisualizar(){
    this.eventoFecharVisualizar.emit();
  }
}
